<script setup lang="ts">
  import { Button, IconSuccess } from "@ui-kit";
  import { useTimer } from "@src/hooks";
  import { ScanModal } from "../ScanModal";

  const emit = defineEmits<{
    "click:home": [value: void];
    "click:more": [value: void];
  }>();

  const { timer } = useTimer(2, () => emit("click:more"));
</script>

<template>
  <ScanModal :title="$t('Связка EPC+КИЗ корректна')" data-testid="correct-pair">
    <template #icon>
      <span class="correct-pair__icon">
        <IconSuccess style="width: 30px; height: 30px; stroke: var(--sf-base-icon-success)" />
      </span>
    </template>
    <template #buttons>
      <Button class="correct-pair__button" variant="secondary" @click="emit('click:more')" data-testid="btn-to-check-pairs">
        {{ $t("Проверить ещё") + " (" + timer + ")" }}
      </Button>
      <Button class="correct-pair__button" variant="secondary" @click="emit('click:home')" data-testid="btn-to-main">
        {{ $t("На главную") }}
      </Button>
    </template>
  </ScanModal>
</template>

<style scoped>
  .correct-pair__icon {
    display: flex;
    border-width: 2px;
    border-style: solid;
    border-radius: 50%;
    padding: 6px;
    margin: 12px;
    border-color: var(--sf-base-icon-success);
  }

  .correct-pair__button {
    white-space: nowrap;
    width: 50%;
  }
</style>
